/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import _ from 'lodash';
import { INITIALIZATION, REQUEST, RESPONSE, ERROR, RESET } from './actions';

export const initialState = {
  method: 'GET',
  url: undefined,
  body: undefined,
  headers: undefined,
  response: {
    body: undefined,
    headers: undefined,
    status: undefined
  },
  value: undefined,
  error: null,
  isRequested: false,
  isCompleted: false,
  isFirstCompleted: false,
  isErrored: false,
  isPending: false,
  isRefreshing: false,
};

function requestReducer(state=initialState, action) {
  switch (action.type) {
    case INITIALIZATION:
    case RESET: {
      // combines any existing state and params from initialization action
      const newState = {
        ...state,
        key: action.key,
        method: action.method || 'GET',
        url: action.url,
        body: action.body,
        headers: action.headers,
        response: {
          body: undefined,
          headers: undefined,
          status: undefined
        },
        value: undefined,
        error: null,
        isRequested: false,
        isCompleted: false,
        isFirstCompleted: false,
        isErrored: false,
        isPending: false,
        isRefreshing: false,
      };

      return newState;
    }
    case REQUEST: {
      // Refreshing is same URL and has been completed
      const refreshing = (state.url === action.url && state.isCompleted);

      return {
        ...state,
        method: action.method || state.method || 'GET',
        url: action.url || state.url,
        body: action.body || state.body,
        headers: action.headers || state.headers,
        error: null,
        isRequested: true,
        isPending: true,
        isCompleted: false,
        isErrored: false,
        isRefreshing: refreshing,
      };
    }
    case RESPONSE: {
      return {
        ...state,
        response: {
          body: action.body,
          headers: action.headers,
          status: action.status
        },
        value: action.body,
        isPending: false,
        isCompleted: true,
        isFirstCompleted: true,
        isErrored: false,
        isRefreshing: false
      };
    }
    case ERROR: {
      return {
        ...state,
        response: {
          body: action.body,
          headers: action.headers,
          status: action.status
        },
        error: action.error,
        isPending: false,
        isCompleted: false,
        isErrored: true,
        isRefreshing: false
      };
    }
    default:
      return state;
  }
}

export default function requestsReducer(state={}, action) {
  if (!_.startsWith(action.type, '@@request')) return state;

  switch (action.type) {
    case INITIALIZATION:
    case REQUEST:
    case RESPONSE:
    case ERROR:
    case RESET:
      return {
        ...state,
        [action.key]: requestReducer(state[action.key], action),
      };
    default:
      return state;
  }
}
